import { render, staticRenderFns } from "./FirebaseUI.vue?vue&type=template&id=00ff45e8&"
import script from "./FirebaseUI.vue?vue&type=script&lang=ts&"
export * from "./FirebaseUI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports